import React, { Component } from "react";
import "./Footer.css";

class Footer extends Component {
  render() {
    return (
      <footer className="main-footer">
        <div className="container">
          <div className="row text-center text-md-start">

            {/* About */}
            <div className="col-md-4 footer-section">
              <h5>🍽️ Welcome to FlavoursNest</h5>
              <p>
              At FlavoursNest, we believe great food brings people together. 
              Explore easy recipes, fresh flavours, and home-cooked goodness made for every kitchen.
              </p>
            </div>

            {/* Quick Links */}
            <div className="col-md-4 footer-section">
              <h5>Quick Links</h5>
              <ul className="footer-links">
                <li><a href="/">Home</a></li>
                <li><a href="/recipes">Recipes</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="col-md-4 footer-section">
              <h5>Contact</h5>
              <p>Email: flavoursnest1@gmail.com</p>

              <div className="social-icons">
                <span>📘</span>
                <span>📸</span>
                <span>🐦</span>
              </div>
            </div>

          </div>

          <hr />

          <div className="text-center copyright">
            © {new Date().getFullYear()} flavoursNest. All rights reserved.
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;